import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Token} from "../model/token.model";
import {NetworkService} from "./network.service";
import {ExchangeService} from "./exchange.service";
import {utf8Decode} from "sdv-common";
import {retryAfterMillis} from "../shared/constants";

@Injectable({providedIn: 'root'})
export class TokenService {

  tokens: Token[] = [];

  constructor(private apiService: ApiService,
              private networkService: NetworkService,
              private exchangeService: ExchangeService) {
    this.load();
  }

  load() {
    this.apiService.get('tokens')
      .subscribe(response => {
        let tokens = [];
        for (const res of response) {
          tokens.push(this.convertToken(res));
        }
        this.tokens = tokens;
      }, err => {
        this.apiService.error({}, err);
        setTimeout(() => this.load(), retryAfterMillis);
      });
  }

  getTokens() {
    return this.tokens;
  }

  private convertToken(dto) {
    return {
      id: utf8Decode(dto.id || ''),
      icon: utf8Decode(dto.icon || ''),
      name: utf8Decode(dto.name || ''),
      symbol: utf8Decode(dto.symbol || ''),
      contract: utf8Decode(dto.contract || ''),
      description: utf8Decode(dto.description || ''),
      exchange_id: dto.exchangeId || 0,
      network_id: dto.networkId || 0,
      decimal: dto.decimal || 0
    };
  }
}
